import { t } from "app/utils";

enum ResponseType {
  accepted = "accepted",
  declined = "declined",
  interested = "interested",
  invited = "invited",
  checked_in = "checked_in"
}

const rsvpResponseTypes = [
  {
    label: t("Yes"),
    value: ResponseType.accepted
  },
  {
    label: t("No"),
    value: ResponseType.declined
  },
  {
    label: t("Interested"),
    value: ResponseType.interested
  },
  {
    label: t("Invited"),
    value: ResponseType.invited
  },
  {
    label: t("Checked In"),
    value: ResponseType.checked_in
  }
];

export const rsvpResponseTypeLabelFrom = (responseType: keyof typeof ResponseType) => {
  const foundResponseType = rsvpResponseTypes.find(({ value }) => value === responseType);
  return foundResponseType ? foundResponseType.label : null;
};

export default rsvpResponseTypes;
